import { supabase } from '../lib/supabase'
import type { PublicationMetric } from './aggregate'

export interface PublishPreviewInput {
  referenceMonth: string
  sourceFileName: string
  sourceSha256: string
  rowCount: number
  metrics: PublicationMetric[]
}

export async function publishIndicatorPreview(input: PublishPreviewInput): Promise<string> {
  const { data, error } = await supabase.rpc('publish_indicator_preview', {
    p_reference_month: input.referenceMonth,
    p_source_file_name: input.sourceFileName,
    p_source_sha256: input.sourceSha256,
    p_row_count: input.rowCount,
    p_metrics: input.metrics,
  })

  if (error) throw error
  if (typeof data !== 'string' || !data) {
    throw new Error('A publicação foi concluída sem retornar o identificador do lote.')
  }
  return data
}
